import { UTMParams } from './types';
const encodeUTMParamsData = (params) => {
    return JSON.stringify(UTMParams.encode(Object.assign({}, params)));
};
export { encodeUTMParamsData };
